export const getCateringPickupMessage = (formatMessage: Function) =>
  formatMessage({ id: 'cateringPickUp' });
